import { render, staticRenderFns } from "./TokenStatCard.vue?vue&type=template&id=49215582&scoped=true"
import script from "./TokenStatCard.vue?vue&type=script&lang=js"
export * from "./TokenStatCard.vue?vue&type=script&lang=js"
import style0 from "./TokenStatCard.vue?vue&type=style&index=0&id=49215582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49215582",
  null
  
)

export default component.exports